import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { history } from '../store/configureStore.js';
import ENV from "../constants/environment";

const reactPlugin = new ReactPlugin();
export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: ENV.APP_INSIGHTS_INSTRUMENTATION_KEY,
    connectionString: ENV.APP_INSIGHTS_CONNECTION_STRING,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    correlationHeaderExcludedDomains: ['*.queue.core.windows.net'],
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history },
    },
  },
});

appInsights.loadAppInsights();

export const withAppInsights = (Component) =>
  withAITracking(reactPlugin, Component);